// 拉取礼物信息
import giftpb from './giftlist.pb';
import mallGiftLabelPb from './mallgiftlabellist.pb';
import packGetPb from './packinfovalid.pb';
import publicpb from '../../base/public.pb';
import PbAjax from '../../lib/pbajax';
import message from '../message/index';
import lang from '../../lang/index';
import gtoGift from './gto/giftomall-giftlist';

let pbajax = new PbAjax();
let gift = {
    giftlistMap: {},
    packData: {},
    hasGuidGift: false,
    getList(scene = 0) {
        let { Request, Response } = giftpb.Mall.GiftList;
        let channel = 'pc' + UP.Global.marketChannel;
        channel = channel.substr(0, 20);
        let UserAgent = 'Android/' + channel + ' version/3.0.0';
        pbajax.do({
                service: 'mall',
                api: '/mall/gift/list',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage,
                    UserAgent: UserAgent 
                },
                insg: this.insg
            },

            new Request({
                scene
            }),

            (res) => {

                var dataWrap = publicpb.Result.decode(res);

                if (dataWrap.code == 1) {
                    this.data = giftpb.Mall.GiftList.Response.decode(dataWrap.data.value);
                    // console.info(this.data);
                    let i = 0,
                        gifts = this.data.gifts,
                        len = gifts.length;
                    let giftlistMap = {};

                    for (i; i < len; i++) {
                        let giftItem = gifts[i];
                        giftlistMap[giftItem.giftId + ""] = giftItem;
                    }

                    this.giftlistMap = { ...this.giftlistMap, ...giftlistMap };

                    if (this.data.amountConfigs.length == 0) {
                        this.data.amountConfigs = [{
                            amount: 1,
                            description: null
                        }];
                    }

                    
                    $.channel.emit('gotGiftList', this.data);

                    // this.preLoadBigPic();
                } else if (dataWrap.code == 8192) {
                    // global.login();
                }

            },
            () => {},
            () => {}
        );
    },
    getGiftLabel(scene) {
        let { Request, Response } = mallGiftLabelPb.Mall.GiftLabelList;
        let defer = $.Deferred();
        let channel = 'pc' + UP.Global.marketChannel;
        channel = channel.substr(0, 20);
        let UserAgent = 'ios/' + channel + ' version/3.0.0';
        pbajax.do({
                service: 'mall',
                api: '/mall/gift/labelList',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage,
                    UserAgent: UserAgent 
                },
                insg: this.insg
            },

            new Request({
                scene
            }),

            (res) => {

                var dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) {
                    this.data = Response.decode(dataWrap.data.value);
                    this.data.gifts = [];
                    
                    let i = 0,
                        gifts = [],
                        len = 0;
                    let giftlistMap = {};
                    let labels = this.data.labels;
                    
                    //生成完整的gift数组
                    for (i = 0; i < labels.length; i++) {
                        gifts = [...gifts, ...labels[i].gifts];
                    }
                    gifts = [...gifts, ...this.data.offlineGifts];
                    // 

                    len = gifts.length;
                    //生成以giftId为key的giftMap
                    for (i = 0; i < len; i++) {
                        let giftItem = gifts[i];
                        giftlistMap[giftItem.giftId + ""] = giftItem;
                    }

                    this.giftlistMap = { ...this.giftlistMap, ...giftlistMap };
                    this.data.gifts = gifts;

                    for (i = 0; i < labels.length; i++) {
                        let onlineGifts = this.getWhiteTypeList(labels[i].gifts);
                        labels[i].onlineGifts = onlineGifts;
                    }

                    if (this.data.amountConfigs.length == 0) {
                        this.data.amountConfigs = [{
                            amount: 1,
                            description: null
                        }];
                    }
                    defer.resolve();

                    // console.error('GiftList:', this.data, this.giftlistMap);
                    $.channel.emit('gotGiftList', this.data);
                    $.channel.emit('gotGiftListForGuid');


                } else if (dataWrap.code == 8192) {
                    // global.login();
                }

            },
            () => {},
            () => {}
        );
        return defer;
    },

    getPacket(scene) {
        let defer = $.Deferred();
        let { Request, Response } = packGetPb.Pack.InfoValid;
        pbajax.do({
                service: 'pack',
                api: '/pack/info/valid',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage
                },
                insg: this.insg
            },

            new Request({
                scene
            }),

            (res) => {
                var dataWrap = publicpb.Result.decode(res);
                if (dataWrap.code == 1) {
                    let packData = Response.decode(dataWrap.data.value);
                    let grids = packData.grids;
                    let giftlistMap = {};
                    for (let i = 0; i < packData.giftInfos.length; i++) {
                        let gift = packData.giftInfos[i];
                        giftlistMap[gift.giftId + ""] = gift;
                    }

                    for (let i = 0; i < grids.length; i++) {
                        let grid = grids[i];
                        let giftId = grid.giftId;
                        grids[i] = { ...grid, ...giftlistMap[giftId] };
                    }
                    this.giftlistMap = { ...this.giftlistMap, ...giftlistMap };
                    grids = this.getGiftPackWhiteTypeList(grids);
                    let propGrids = this.getPackPropInfo(packData);
                    let giftPack = [...grids,...propGrids];

                    packData.grids = giftPack;
                    this.data.packData = packData;

                } else if (dataWrap.code == 8192) {
                    // global.login();
                }
                defer.resolve(this.data);

            },
            () => {},
            () => {}
        );
        return defer;

    },
    getPackPropInfo(packData){
        let propGrids = packData.propGrids;
        let propInfos = packData.propInfos;
        let len = propGrids.length;
        let reuslt = [];
        for(let i = 0; i < len; i++){
            let proGrid = propGrids[i];
            for(let j = 0; j<len; j++){
                let info = propInfos[j];
                if(proGrid.giftId == info.giftId){
                    proGrid.pic = this.getGiftPicFromObj(info);
                    proGrid.price = 0;
                    proGrid.type = 888;//道具 本地定义
                    proGrid.name = info.name;
                    reuslt[reuslt.length] = proGrid;
                    break;
                }
            }
        }
        return reuslt;

    },

    isWhiteType(type){
        let whiteTypeList = [1, 12, 6, 7, 16, 24];
        
        if(whiteTypeList.indexOf(type) > -1){
            return true;
        }
        return false;
    },


    getGiftPackWhiteTypeList(giftList = []) {

        let list = giftList;
        let result = [];
        // let whiteTypeList = [1, 12, 13, 6, 7, 16, 24];
        for (let i = 0, len = list.length; i < len; i++) {
            let item = list[i];
            if (item.produceType == 1  && !item.guardLevel) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0; // 新手引导礼物 price: null
                result.push(item);
            }
        }
        return result;
    },

    getWhiteTypeList(giftList = []) {

        let list = giftList;
        let result = [];
        // let whiteTypeList = [1, 12, 13, 6, 7, 16, 24];
        let whiteTypeList = [1, 12, 6, 7, 16, 24];
        
        for (let i = 0, len = list.length; i < len; i++) {
            let item = list[i];
            if(item.type == 16 && item.onLined){
                this.hasGuidGift = true;
            }
            if (item.produceType == 1  && (whiteTypeList.indexOf(item.type) > -1) && !item.guardLevel) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0; // 新手引导礼物 price: null
                result.push(item);
            }
        }
        
        return result;
    },

    getOnlineGift(giftList = []) {
        let list = giftList.length > 0 ? giftList : this.data.gifts;
        let result = [];
        // let whiteTypeList = [1, 12, 13, 6, 7, 16, 24];
        let whiteTypeList = [1, 12, 6, 7, 16, 24];  // 红包有问题, 屏蔽处理
        /**
            type 礼物类型：
            1: 静态；2:动态；3:弹幕; 4:文本翻译; 5: 弹幕翻译; 6:精灵; 7:精灵球; 8:点击精灵; 
            9: 宝箱; 10:守护; 11: goole翻译; 12:大动画; 13: 红包; 14: 悄悄话; 15:悄悄话翻译;
            16:新手引导礼物; 17:免费礼物; 19:全区喇叭; 23: 免费无时限装饰; 24:用户打赏装饰; 25:七彩弹幕
            26: 动画弹幕; 27:视频贴纸
         */
        for (let i = 0, len = list.length; i < len; i++) {
            let item = list[i];

            if (item.onLined && item.produceType == 1 && (whiteTypeList.indexOf(item.type) > -1) && !item.guardLevel) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0; // 新手引导礼物 price: null
                result.push(item);
            }

            if (item.produceType == 2) {
                // U钻礼物
                // console.log(item,'++++');
            }
        }

        return result;
    },

    getOnlineCheapGift() {
        let onlineList = this.getOnlineGift();

        let list = [];

        for (var len = onlineList.length, i = 0; i < len; i++) {
            let item = onlineList[i];

            if (parseInt(item.price, 10) == 10) {
                list[list.length] = item;
            }
        }

        return list;
    },

    // 从在线礼物列表中获取 大礼物图片列表
    // 要排除canCombo的连发图片（不会播大动画）
    getBigGiftPicList() {
        let onlineList = this.getOnlineGift();
        let picList = [];
        for (var i = onlineList.length; i--;) {
            let item = onlineList[i];
            if (item.canCombo) {
                continue;
            }
            picList.push(this.getNormalPic(item.resources).big)
        }

        return picList;
    },

    // 换算成二维数组
    formatDyadicArray(arr, unitCount = 8) {
        let result = [];
        // let unitCount = 8;
        for (let i = 0, len = arr.length; i < len; i += 8) {
            result.push(arr.slice(i, i + unitCount));
        }
        return result;
    },

    getGiftFromId(giftId) {
        if (!this.data) {
            return;
        }

        if (giftId == 2005) {
            return {
                giftId,
                name: ''
            }
        }
        
        let result;
        let gifts = this.giftlistMap;
        let gift = gifts[giftId];

        if (gift) {
            result = { ...gift };
        }

        return result;
    },

    // 根据礼物id查询礼物图片, 包括big、samll
    getGiftPicFromId(giftId) {
        if (!this.data) {
            return;
        }

        let gift = this.getGiftFromId(giftId);

        if (!gift) {
            return;
        }
        let pic = this.getNormalPic(gift.resources);

        return pic;
    },

    getGiftPicFromObj(gift){
        if (!gift) {
            return;
        }
        let pic = this.getNormalPic(gift.resources);

        return pic;
    },

    // type 1：大图，2：中图，3：小图，4：大动画，5：中动画，6：小动画，7：声音
    getNormalPic(resources) {
        let ret = {};

        resources.forEach((item) => {
            switch (item.type) {
                case 1:
                    ret.big = item.url;
                    break;
                case 2:
                    ret.middle = item.url;
                    break;
                case 3:
                    ret.small = item.url;
                    break;
                case 4:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.big = item.url;
                    break;
                case 5:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.middle = item.url;
                    break;
                case 6:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.small = item.url;
                    break;
                case 7:
                    ret.voice = item.url;
                    break;
            }
        });

        return ret;
    },

    // 预加载大图片
    preLoadBigPic() {
        let allpic = this.getBigGiftPicList();

        let preload = (inx) => {
            if (inx >= allpic.length) {
                return;
            }
            let img = new Image();
            img.src = allpic[inx];
            if (img.complete) {
                preload(inx + 1);
            } else {
                img.onload = function() {
                    preload(inx + 1);
                }
            }
        };

        preload(0);
    },

    // 精灵球
    getPokemonBall() {
        return this.getGiftFromId(2057) || {};
    },
    getGiftObj(giftBody){
        
        let giftType = giftBody.giftType || 0;
        let giftId = giftBody.giftId;
        let giftObj;
        //服务端消息  giftType = 1 GTO 礼物  0 普通礼物
        if (giftType == 1){
            giftObj = gtoGift.getGiftFromId(giftId);
        } else {
            giftObj = this.getGiftFromId(giftId);
        }
        
        return giftObj;

    }

};

export default gift;


// WEBPACK FOOTER //
// ./js/living/gift/giftlist.js